<template>
    <div>
        <b-modal ref="modalCalendar" id="modalCalendar" no-close-on-backdrop no-close-on-esc centered hide-footer hide-header>
            <div class="close" @click="$bvModal.hide('modalCalendar')"><img src="/svg/close-white.svg" alt=""></div>
            <div class="d-block position-relative">
                <div class="title title-3">Выберите срок аренды</div>
                <p class="subtitle">Выберите дату начала и дату окончания аренды.</p>
                <calendar-app class="calendar"></calendar-app>
            </div>

            <button @click="hide()"
                    class="modalCalendar-button"
                    :disabled="!store.state.dates.start ||
                    !store.state.dates.end ||
                    !store.state.timeStart.HH ||
                    !store.state.timeEnd.HH ||
                    !store.state.timeStart.mm ||
                    !store.state.timeEnd.mm" >
                применить
            </button>
        </b-modal>
    </div>
</template>

<script>
    import store from '../../services/data';
    export default {
        data() {
            return {
                store: store,
            }
        },

        methods: {
            hide() {
                this.$refs.modalCalendar.hide();
            },
        }
    }
</script>
